import {Injectable} from '@angular/core';
import {CanActivate,CanLoad, RouterStateSnapshot, ActivatedRouteSnapshot,Router} from "@angular/router";
import { Headers, Http, Response,RequestOptions }  from '@angular/http';

const APPAPI = '/coapi'; 
@Injectable()
export class CanActivateGuard implements CanActivate {
    perMi:any;
    private APPAPI:any
    constructor(public http: Http ,private _router: Router,) {
        this.http = http;
        this.APPAPI = APPAPI;
       
      }

    
    canActivate() {
        this.perMi = sessionStorage.getItem("perMi")
        if(this.perMi == "1"){
            return true;
        }else{
            return false;
        }
    }

   


    login(username,password) : Promise<any[]>{
        let headers = new Headers({'content-type':'application/json'});
        let options = new RequestOptions({ headers: headers});
            let aupara ={
                loginName:username,
                password:password
            };

            return this.http.post(APPAPI+"/api/login",aupara,options)
            .toPromise()
            .then(this.extractData).catch();
      }

      
      public extractData(res: Response) {
        let body = res.json(); 
        return body || { };
      }
    
    
}


// WEBPACK FOOTER //
// /srv/jenkins-test/workspace/dev-doc-web/src/app/Services/can-activate-guard.ts